import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

/**
 * Aplicar em um elemento overlay ancorado acima do rodapé (position: absolute;
 * bottom: 100%) que cobre a parte de baixo da área rolável — ex.: o resumo de
 * itens selecionados das telas de complementos/pizza.
 *
 * Mantém o padding de baixo da área rolável igual à altura do overlay, para o
 * fim da lista nunca ficar escondido embaixo dele. O overlay fica FORA do fluxo
 * justamente para o container de scroll nunca mudar de tamanho: redimensionar o
 * container dispara o re-clamp do scroll por toque no iOS/WebKit (pulos e itens
 * inalcançáveis). Crescer só o padding altera apenas o scrollHeight, o que todos
 * os engines tratam corretamente.
 *
 * Escrita para o `<ion-content>`, a diretiva ficou inerte na desionização: procurava
 * `ion-content`, que virou `.mp-content`, e o guard a desligava em silêncio — o último
 * complemento passou a ficar atrás do rodapé (relatado em blue 02/09/2026). Escrever
 * `--padding-bottom` também deixou de servir: aquela era a variável do ion-content, e o
 * `.mp-content` é um <div> com overflow-y:auto, que não lê variável nenhuma. Por isso o
 * padding é aplicado direto. Ver overlay-scroll-padding.directive.spec.ts.
 */
@Directive({ selector: '[appOverlayScrollPadding]' })
export class OverlayScrollPaddingDirective implements AfterViewInit, OnDestroy {
	private resizeObserver: any;

	constructor(private elRef: ElementRef<HTMLElement>) {}

	ngAfterViewInit() {
		const ResizeObserverCtor = (window as any).ResizeObserver;
		if (!ResizeObserverCtor) return;

		const overlay = this.elRef.nativeElement;
		// primeiro ancestral que contém a área rolável = a própria página
		// (não usar closest('.mp-page'): o router só adiciona a classe depois)
		let scope = overlay.parentElement;
		while (scope && !scope.querySelector('.mp-content')) scope = scope.parentElement;
		const content = scope && (scope.querySelector('.mp-content') as HTMLElement);
		if (!content) return;

		this.resizeObserver = new ResizeObserverCtor(() => {
			content.style.paddingBottom = overlay.offsetHeight + 'px';
		});
		this.resizeObserver.observe(overlay);
	}

	ngOnDestroy() {
		if (this.resizeObserver) this.resizeObserver.disconnect();
	}
}
